// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.close-btn {
  position: absolute;
  right: 6px;
  color: #ffff;
  top: 4px;
}

.width-100 {
  width: 100%;
}

.modal-header {
  position: relative;
  height: 40px;
}

.containerX {
  padding-bottom: 0px;
}

.modal-header h3 {
  text-align: center;
  line-height: 29px;
  margin: 0px;
  font-size: 17px;
  color: #fff;
  font-family: 'Inter Regular';
  background: #003561;
  font-weight: 500;
  height: 30px;
}

:host ::ng-deep .mat-dialog-container {
  color: #999;
}

.m-0 {
  margin: 0px;
}

.img-100 {
  width: 100%;
}

.shared-text {
  font-size: 14px;
  color: #999;
  margin: 5px 0px;
  float: left;
  white-space: nowrap;
  width: 100%;
  letter-spacing: 1px;
}

.link-text {
  font-style: italic;
  color: #333;
  width: 75%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 4px;
  float: left;
  border: 1px #eee solid;
  border-radius: 4px;
  padding: 3px;
  background-image: linear-gradient(to top, #e6e9f0 0%, #eef1f5 100%);
}

.shared-show {
  position: relative;
  border: 1px #92929e solid;
  border-radius: 4px;
  padding: 5px 10px;
  margin-top: 10px;
}

.shared-show .mat-stroked-button {
  padding: 0 7px;
  line-height: 26px;
  font-size: 12px;
  letter-spacing: 1px;
  float: left;
  color: #003561;
  background-color: #fff;
  right: 10px;
  position: absolute;
}

h4 {
  font-family: 'Inter Regular';
  letter-spacing: 1px;
  font-weight: 100;
  color: #003561;
  margin: 5px 0px;
  padding-bottom: 5px;
  text-align: center;
}

.tagline {
  margin: 0px;
  letter-spacing: 1px;
  font-family: sans-serif;
  font-size: 13px;
}

.label-text {
  font-family: 'Inter Regular';
  letter-spacing: 1px;
  color: #003561;
  margin: 7px 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/app-share-map-module/share-link-and-embed-modal/share-link-and-embed-modal.component.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,WAAW;EACX,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;EACZ,mEAAmE;AACrE;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB","sourcesContent":[".close-btn {\n  position: absolute;\n  right: 6px;\n  color: #ffff;\n  top: 4px;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n.modal-header {\n  position: relative;\n  height: 40px;\n}\n\n.containerX {\n  padding-bottom: 0px;\n}\n\n.modal-header h3 {\n  text-align: center;\n  line-height: 29px;\n  margin: 0px;\n  font-size: 17px;\n  color: #fff;\n  font-family: 'Inter Regular';\n  background: #003561;\n  font-weight: 500;\n  height: 30px;\n}\n\n:host ::ng-deep .mat-dialog-container {\n  color: #999;\n}\n\n.m-0 {\n  margin: 0px;\n}\n\n.img-100 {\n  width: 100%;\n}\n\n.shared-text {\n  font-size: 14px;\n  color: #999;\n  margin: 5px 0px;\n  float: left;\n  white-space: nowrap;\n  width: 100%;\n  letter-spacing: 1px;\n}\n\n.link-text {\n  font-style: italic;\n  color: #333;\n  width: 75%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-top: 4px;\n  float: left;\n  border: 1px #eee solid;\n  border-radius: 4px;\n  padding: 3px;\n  background-image: linear-gradient(to top, #e6e9f0 0%, #eef1f5 100%);\n}\n\n.shared-show {\n  position: relative;\n  border: 1px #92929e solid;\n  border-radius: 4px;\n  padding: 5px 10px;\n  margin-top: 10px;\n}\n\n.shared-show .mat-stroked-button {\n  padding: 0 7px;\n  line-height: 26px;\n  font-size: 12px;\n  letter-spacing: 1px;\n  float: left;\n  color: #003561;\n  background-color: #fff;\n  right: 10px;\n  position: absolute;\n}\n\nh4 {\n  font-family: 'Inter Regular';\n  letter-spacing: 1px;\n  font-weight: 100;\n  color: #003561;\n  margin: 5px 0px;\n  padding-bottom: 5px;\n  text-align: center;\n}\n\n.tagline {\n  margin: 0px;\n  letter-spacing: 1px;\n  font-family: sans-serif;\n  font-size: 13px;\n}\n\n.label-text {\n  font-family: 'Inter Regular';\n  letter-spacing: 1px;\n  color: #003561;\n  margin: 7px 0px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
